module.exports = __webpack_public_path__ + "media/img/payment-methods/default-d24f0147c38e015f6c8ee7016db42418.svg";